//jQuery( document ).ready(function( $ ) {
//  a
//});// ==========================
//  YOUNIX CUSTOM JS
//  Gestione cambio lingua ITA / ENG
//  Ultima versione - stabile
// ==========================

(function () {
  // Non intervenire su carrello / checkout
  if (/^\/(cart|checkout)/.test(location.pathname)) return;

  console.log('[Younix] Lang switch ready');

  // ----------------------------
  // Funzione: genera URL della stessa pagina nella lingua target
  // ----------------------------
  function toLangUrl(target) {
    var url  = new URL(window.location.href);
    var path = url.pathname;

    if (!path.startsWith('/')) path = '/' + path;

    if (target === 'it') {
      if (path === '/') path = '/it/';
      else if (!path.startsWith('/it/')) path = '/it' + path;
    } else {
      if (path === '/it') path = '/';
      else if (path.startsWith('/it/')) path = path.substring(3); // rimuove /it
    }

    url.pathname = path;
    return url.toString();
  }

  // ----------------------------
  // Listener globale per i click
  // Intercetta SOLO le bandierine
  // ----------------------------
  document.addEventListener('click', function (ev) {
    var link = ev.target.closest('a');
    if (!link) return;

    var href = link.getAttribute('href') || '';

    // Cerca un'immagine nel link (le bandierine hanno sempre <img>)
    var img = link.querySelector('img');
    var imgAlt = img ? (img.getAttribute('alt') || '') : '';
    var imgSrc = img ? (img.getAttribute('src') || '') : '';

    // Riconoscimento bandiera ITA
    var looksLikeIT =
      img && (
        /italy/i.test(imgAlt) ||
        /bandiera-italiana/i.test(imgSrc) ||
        /italiana/i.test(imgAlt)
      );

    // Riconoscimento bandiera ENG
    var looksLikeEN =
      img && (
        /\buk\b|\benglish\b|\beng\b/i.test(imgAlt) ||
        /bandiera-uk/i.test(imgSrc)
      );

    // Fallback: se è link home ma contiene immagine bandiera
    var isHomeIT = img && (/^\/it\/?$/.test(href) || /^https?:\/\/[^\/]+\/it\/?$/.test(href));
    var isHomeEN = img && (/^\/?$/.test(href)      || /^https?:\/\/[^\/]+\/?$/.test(href));

    // Se è bandiera IT → passa alla stessa pagina in ITA
    if (looksLikeIT || isHomeIT) {
      ev.preventDefault();
      var targetUrlIT = toLangUrl('it');
      console.log('[Younix] → IT', targetUrlIT);
      window.location.assign(targetUrlIT);
      return;
    }

    // Se è bandiera ENG → passa alla stessa pagina in ENG
    if (looksLikeEN || isHomeEN) {
      ev.preventDefault();
      var targetUrlEN = toLangUrl('en');
      console.log('[Younix] → EN', targetUrlEN);
      window.location.assign(targetUrlEN);
      return;
    }

    // Tutti gli altri link (es. HOME, MENU, ecc.) continuano normalmente
  }, false);
})();
